module.exports = __webpack_public_path__ + "static/media/permission.598fbe8d.svg";